module.exports = __webpack_public_path__ + "static/genesis-logo-6e8c64e4090912eeb5044c28e3f362cf.png";